import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ServiceShortItem.module.scss';
import { salonManagementActions } from 'Containers/SalonManagement/store';
import clx from 'classnames';
import { useDispatch } from 'react-redux';
import { Clock3, Pencil, Ban, RotateCcw } from 'lucide-react';

export const ServiceShortItem = ({
  service,
  openEditServiceModal,
  setServiceToDeleteId,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const price = Number.isFinite(parseFloat(service.cost))
    ? parseFloat(service.cost).toFixed(2)
    : '0.00';

  return (
    <article
      className={clx(styles.card, {
        [styles.card_disabled]: !!service.disabled,
      })}
    >
      <div className={styles.main}>
        <h4 className={styles.name}>{service.name}</h4>
        <div className={styles.meta}>
          <span className={styles.pill}>
            <Clock3 size={13} strokeWidth={2.3} aria-hidden />
            {service.duration} {t('workers.serviceList.serviceItem.minutes')}
          </span>
          <span className={styles.pill}>€ {price}</span>
          {service.onlyVisibile ? (
            <span className={clx(styles.pill, styles.pill_muted)}>
              {t('workers.serviceList.filters.visibleOnlyInManagement')}
            </span>
          ) : null}
        </div>
      </div>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.action_btn}
          onClick={() => openEditServiceModal(service)}
        >
          <Pencil size={15} strokeWidth={2.3} aria-hidden />
          {t('workers.serviceList.serviceItem.edit')}
        </button>

        {!service.disabled ? (
          <button
            type="button"
            className={clx(styles.action_btn, styles.action_btn_danger)}
            onClick={() => setServiceToDeleteId(service.id)}
          >
            <Ban size={15} strokeWidth={2.3} aria-hidden />
            {t('common.actions.disable')}
          </button>
        ) : (
          <button
            type="button"
            className={clx(styles.action_btn, styles.action_btn_primary)}
            onClick={() =>
              dispatch(
                salonManagementActions.EDIT_WORKER_SERVICE.REQUEST({
                  disabilitato: 0,
                  idServiziPoltrona: service.id,
                }),
              )
            }
          >
            <RotateCcw size={15} strokeWidth={2.3} aria-hidden />
            {t('workers.serviceList.serviceItem.enable')}
          </button>
        )}
      </div>
    </article>
  );
};
